<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
@if (data$|async; as chartData) {
  <div
    (click)='onChartClick($event)' fxFlexFill>
    @switch (definition.chartConfig.type) {
      @case ('pie') {
        <ngx-charts-pie-chart
          [view]="dimensions$|async"
          [results]="chartData"
          [scheme]="config.scheme"
          [schemeType]="config.schemeType || 'ordinal'"
          [gradient]="config.gradient"
          [labels]="true"
          [labelFormatting]="formatLabels"
          [maxLabelLength]="20"
          [legend]="config.legend"
          [legendPosition]="config.legendPosition"
          [legendTitle]="config.legendTitle"
          [doughnut]="config.doughnut"
          [arcWidth]="config.arcWidth"
          [animations]="!isPrinting"
          (select)='onSeriesClick($event)'
        ></ngx-charts-pie-chart>
      }
      @case ('bar') {
        <ngx-charts-bar-vertical
          [view]="undefined"
          [results]="chartData"
          [scheme]="config.scheme"
          [schemeType]="config.schemeType || 'ordinal'"
          [showDataLabel]="config.showDataLabel"
          [xAxis]="config.xAxis"
          [yAxis]="config.yAxis"
          [yScaleMin]="config.yScaleMin"
          [yScaleMax]="config.yScaleMax"
          [showXAxisLabel]="!!(config.xAxisLabel)"
          [showYAxisLabel]="!!(config.yAxisLabel)"
          [xAxisLabel]="config.xAxisLabel"
          [yAxisLabel]="config.yAxisLabel"
          [xAxisTickFormatting]="getXAxisTickFormatter()"
          [legend]="config.legend"
          [legendPosition]="config.legendPosition"
          [legendTitle]="config.legendTitle"
          [legendColumns]="config.legendColumns"
          [animations]="!isPrinting"
          (select)='onSeriesClick($event)'
        ></ngx-charts-bar-vertical>
      }
      @case ('line') {
        <ngx-charts-line-chart
          [view]="dimensions$|async"
          [results]="chartData"
          [scheme]="config.scheme"
          [schemeType]="config.schemeType || 'ordinal'"
          [xAxis]="config.xAxis"
          [yAxis]="config.yAxis"
          [yScaleMin]="config.yScaleMin"
          [yScaleMax]="config.yScaleMax"
          [showXAxisLabel]="!!(config.xAxisLabel)"
          [showYAxisLabel]="!!(config.yAxisLabel)"
          [xAxisLabel]="config.xAxisLabel"
          [yAxisLabel]="config.yAxisLabel"
          [legend]="config.legend"
          [legendPosition]="config.legendPosition"
          [legendTitle]="config.legendTitle"
          [animations]="!isPrinting"
          (select)='onSeriesClick($event)'
        ></ngx-charts-line-chart>
      }
    }
  </div>
}
